export class WeakRegistry {
    map = new Map();
    finalizationRegistry = new FinalizationRegistry((key) => {
        // console.log('WeakRegistry: finalization', key)
        this.map.delete(key);
    });
    get = (key) => {
        const ref = this.map.get(key);
        if (!ref) {
            return undefined;
        }
        const object = ref.deref();
        if (!object) {
            // console.log('WeakRegistry: get-remove', key)
            this.map.delete(key);
            return undefined;
        }
        return object;
    };
    getOrCreate = (key, factory) => {
        const existing = this.get(key);
        if (existing) {
            return existing;
        }
        const value = factory();
        this.set(key, value);
        return value;
    };
    mutateOrCreate = (args) => {
        const existing = this.get(args.key);
        if (existing) {
            args.mutate(existing);
            return existing;
        }
        else {
            const newValue = args.create();
            this.set(args.key, newValue);
            return newValue;
        }
    };
    set = (key, value) => {
        this.finalizationRegistry.register(value, key);
        this.map.set(key, new WeakRef(value));
    };
}
//# sourceMappingURL=WeakRegistry.js.map